//-- Copyright (c) 2021 TMT Insights Group, LLC
import { createSelector } from '@reduxjs/toolkit';
import { NotificationRecord, NotificationState, NotificationVisibility } from '../slices/notificationSlice';
import { RootState } from '../store';
import { Pagination } from '../slices/slice_types';

const selectNotification = (state: RootState): NotificationState => state.notification;
export const selectNotifications = (showAll: boolean, groupType: string) =>
  createSelector(
    selectNotification,
    (notification): NotificationRecord[] => notification.data[showAll ? NotificationVisibility.ALL : NotificationVisibility.UNSEEN][groupType] || []
  );
export const selectNotificationTab = (state: RootState): NotificationState['notificationTab'] => state.notification.notificationTab;
export const selectHasUnseenNotifications = (state: RootState): boolean => {
  const stats = state.notification.unseenNotificationStats;
  if (!stats || !stats.group_types) {
    return false;
  }
  return Object.values(stats.group_types).reduce((prev, next) => prev + next, 0) > 0;
};
export const selectNotificationsLoading = (state: RootState): NotificationState['loading'] => state.notification.loading;
export const selectNotificationPagination = (visibility: NotificationVisibility, type: string) =>
  createSelector(selectNotification, (notification): Pagination => notification.pagination[visibility][type]);
export const selectNotificationPaginations = (visibility: NotificationVisibility) =>
  createSelector(selectNotification, (notification): Record<string, Pagination> => notification.pagination[visibility]);
export const selectNotificationSettings = (state: RootState): NotificationState['settings'] => state.notification.settings;
export const selectHasNoNotificationsEnabled = (state: RootState): boolean => {
  const values = Object.values(state.notification.settings?.in_app || {});

  return !values.some((setting) => setting.enabled);
};
export const selectUnseenNotificationStats = (state: RootState): NotificationState['unseenNotificationStats'] =>
  state.notification.unseenNotificationStats;

export const selectNotificationGroupTypes = (state: RootState): NotificationState['group_types'] => state.notification.group_types;
